<template>
  <v-app-bar
    id="default-app-bar"
    app
    absolute
    class="v-bar--underline pt-4"
    color="transparent"
    :clipped-left="$vuetify.rtl"
    :clipped-right="!$vuetify.rtl"
    height="30"
    flat
  >
    <v-app-bar-nav-icon
      class="hidden-md-and-up"
      @click="drawer = !drawer"
    />

    <default-drawer-toggle class="hidden-sm-and-down" />

    <v-toolbar-title
      class="font-weight-light text-h5"
      v-text="pageName"
    />

    <v-spacer />

    <!-- <default-search class="hidden-sm-and-down" />

    <default-go-home />

    <default-notifications /> -->
    <span>Welcome, {{ firstName }}</span>
    <default-account />
  </v-app-bar>
</template>

<script>
  // Utilities
  import { get, sync } from 'vuex-pathify'
  import { splitIntoWords } from '@/util/helpers'

  export default {
    name: 'DefaultBar',

    components: {
      DefaultAccount: () => import(
        /* webpackChunkName: "default-account" */
        './widgets/Account'
      ),
      DefaultDrawerToggle: () => import(
        /* webpackChunkName: "default-drawer-toggle" */
        './widgets/DrawerToggle'
      ),
    },
    data () {
      return {
        pageName: '',
      }
    },
    computed: {
      ...sync('app', [
        'drawer',
        'mini',
      ]),
      ...get('user', [
        'firstName',
      ]),
      name: get('route/name'),
    },
    watch: {
      name () {
        this.updateName()
      },
    },
    created () {
      this.updateName()
    },
    methods: {
      updateName () {
        this.pageName = splitIntoWords(this.name)
      },
    },
  }
</script>
